import React from "react"
import { Wrapper, InnerWrapper } from "./CityCard.styles"
import { InfoTag } from "atom"
import BackgroundImage from "gatsby-background-image"
import plus from './icons/plus.svg'
import minus from './icons/minus.svg'

const CityCard = ({
  title,
  secondaryText,
  order = 100,
  type = "regular",
  backgroundImage = "",
  dataPoints = [],
  selectCity,
  selected,
  originalItem,
  selectedUnit
}) => {
  return (
    <Wrapper order={order} type={type} onClick={() => selectCity(originalItem)} >
      <BackgroundImage
        Tag="section"
        className={"background"}
        fluid={backgroundImage}
        backgroundColor={`white`}
      >
        <InnerWrapper>
          <h3>
            <span>{title}</span>
            <span>{`  · ${secondaryText}`}</span>
          </h3>

          <ul>
            {dataPoints.map((dataPoint, index) => {
              const { title, value, type } = dataPoint
              if (value != "NaN") {
                return (
                  <InfoTag
                    key={`${index.toString()}-${title}`}
                    title={title}
                    secondaryText={secondaryText}
                    value={value}
                    selectedUnit={selectedUnit}
                  />
                )
              }
            })}
          </ul>
        </InnerWrapper>
      </BackgroundImage>
    </Wrapper>
  )
}

export default CityCard
